/**
 * Progressive enhancement for the collection intro's "Lees meer" toggle (Mees feedback
 * 2026-09-22, item 4). The markup renders the description in full and the toggle button
 * starts `hidden`, so without this script the page is already correct. With it, each
 * `[data-collection-intro]` block is measured against its own clamped height: only when
 * `scrollHeight` overflows `clientHeight` does the toggle appear and the clamp apply.
 */
function initCollectionIntroClamp() {
  document.querySelectorAll('[data-collection-intro]').forEach((text) => {
    const toggle = text.parentElement?.querySelector('[data-collection-intro-toggle]');
    if (!toggle) return;

    const check = () => {
      const wasExpanded = text.classList.contains('is-expanded');

      // Temporarily remove is-expanded to measure the clamped state
      if (wasExpanded) text.classList.remove('is-expanded');

      text.classList.add('is-clamped');
      const overflowing = text.scrollHeight > text.clientHeight + 1;

      // Restore is-expanded if it was expanded
      if (wasExpanded) text.classList.add('is-expanded');

      if (overflowing) {
        toggle.hidden = false;
      } else {
        text.classList.remove('is-clamped', 'is-expanded');
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }
    };

    if (!toggle.dataset.introBound) {
      toggle.dataset.introBound = 'true';
      toggle.addEventListener('click', () => {
        const expanded = text.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
      });
    }

    check();
  });
}

initCollectionIntroClamp();

// Re-checked on resize (debounced) since the two-line height depends on viewport width, and
// exposed on window so collection-filters.js can re-run it after swapping in a fresh header.
window.initCollectionIntroClamp = initCollectionIntroClamp;

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(initCollectionIntroClamp, 150);
});
